import { defineMessages, useIntl } from 'react-intl';
import { AnimatePresence } from 'motion/react';
import { Tooltip } from 'src/components';
import * as S from './styles';
import GLIcon from './icon';

const msgs = defineMessages({
  tooltipFlower: {
    id: 'learning_session_tooltip_flower',
  },
  tooltipAlreadyKnown: {
    id: 'learning_session_tooltip_already_known',
  },
});

interface GrowthLevelIndicatorProps {
  growthLevel: number;
  className?: string;
  isItemDueForReview?: boolean;
  alreadyKnown?: boolean;
  difficult?: boolean;
}

export const GrowthLevelIndicator = ({
  growthLevel,
  className,
  isItemDueForReview,
  alreadyKnown,
  difficult,
}: GrowthLevelIndicatorProps) => {
  const intl = useIntl();

  const getAlexIcon = () => {
    if (alreadyKnown) {
      return <GLIcon name="alreadyKnown" />;
    }

    if (isItemDueForReview) {
      return <GLIcon name="glreview" />;
    }

    if (growthLevel >= 7) {
      return <GLIcon name="gl6" />;
    }

    switch (growthLevel) {
      case 0:
        return <GLIcon name="gl0" />;
      case 1:
        return <GLIcon name="gl1" />;
      case 2:
        return <GLIcon name="gl2" />;
      case 3:
        return <GLIcon name="gl3" />;
      case 4:
        return <GLIcon name="gl4" />;
      case 5:
        return <GLIcon name="gl5" />;
      case 6:
        return <GLIcon name="gl6" />;
    }
  };

  const isDifficult = difficult && !alreadyKnown;

  return (
    <Tooltip
      placement="auto"
      tooltip={intl.formatMessage(alreadyKnown ? msgs.tooltipAlreadyKnown : msgs.tooltipFlower)}
    >
      <S.Wrapper data-testid="growthLevelIndicator" className={className}>
        <AnimatePresence>
          <S.IconContainer $positionRelative={isDifficult}>
            <S.MainIcon>{getAlexIcon()}</S.MainIcon>
            {isDifficult && <S.Icon name="lightningBoltInCircle" />}
          </S.IconContainer>
        </AnimatePresence>
      </S.Wrapper>
    </Tooltip>
  );
};
